// Accordion init: funkar för hur många instanser som helst på samma sida
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-accordion]').forEach(function (container) {
    container.querySelectorAll('.collapsible').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('active');
        var content = btn.nextElementSibling;
        if (!content) return;

        // Toggle display el. klass (båda funkar – välj en)
        if (content.classList) {
          content.classList.toggle('open');
        }

        // Fallback om du använder inline display:
        if (content.style.display === 'block') {
          content.style.display = 'none';
        } else if (content.style.display === '' || content.style.display === 'none') {
          content.style.display = 'block';
        }
      });
    });
  });
});
